import classNames from 'classnames'
import onClickOutside from 'react-onclickoutside'
import { Option } from './SelectField'
import { FieldValues, Path, PathValue } from 'react-hook-form'
import styles from './styles.module.scss'

type SelectDropdownProps<T extends FieldValues> = {
  direction: 'up' | 'down'
  options: Option[]
  selectedValue: string
  handleSelect: (value: PathValue<T, Path<T>>) => void
  hasLabel: boolean
  id: string
}

function SelectDropdown<T extends FieldValues>({
  direction,
  options,
  selectedValue,
  handleSelect,
  hasLabel,
  id
}: SelectDropdownProps<T>) {
  return (
    <ul
      className={classNames(styles.Options, {
        [styles.openUpwards]: direction === 'up',
        [styles.withLabel]: hasLabel
      })}
      id={`${id}-listbox`}
      role="listbox"
    >
      {options.map(opt => (
        <li
          key={opt.value}
          role="option"
          data-testid={`list-option-${opt.value}`}
          aria-selected={opt.value === selectedValue}
          aria-disabled={!opt.available}
          className={classNames(styles.SelectOption, {
            [styles.selected]: opt.value === selectedValue,
            [styles.disabled]: !opt.available
          })}
          onMouseDown={e => e.preventDefault()}
          onClick={() =>
            opt.available && handleSelect(opt.value as PathValue<T, Path<T>>)
          }
          onKeyDown={e => {
            if (!opt.available) return
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleSelect(opt.value as PathValue<T, Path<T>>)
            }
          }}
        >
          {opt.icon && <>{opt.icon}</>}
          <span>{opt.label}</span>
        </li>
      ))}
    </ul>
  )
}

export default onClickOutside(SelectDropdown)
